export const LIST_ROOM_MOVES = 'LIST_ROOM_MOVES'
export const LIST_ROOM_MOVES_SUCCESS = 'LIST_ROOM_MOVES_SUCCESS'
export const LIST_ROOM_MOVES_FAILED = 'LIST_ROOM_MOVES_FAILED'

export const CLEAR_ROOM_MOVE_LISTS = 'CLEAR_ROOM_MOVE_LISTS'

export const VALIDATE_ROOM_MOVES = 'VALIDATE_ROOM_MOVES'
